import moment from 'moment';
import Utils from './components/utils';

const { operatorsTypes, departments, places } = Utils.options();

export const TYPE_META = {
    operator: { chip: 'pc-emp-chip--acc', av: 'operator' },
    leader: { chip: 'pc-emp-chip--vio', av: 'super' },
    senior: { chip: 'pc-emp-chip--ok', av: 'manager' },
    staf: { chip: '', av: 'admin' },
    test: { chip: '', av: 'admin' },
};

export const TYPE_ORDER = ['operator', 'leader', 'senior', 'staf', 'test'];

export const typeLabel = (type) => {
    const id = typeof type === 'object' && type ? (type.id || type._id || type.code) : type;
    return operatorsTypes.find((item) => item.id === id)?.name || (typeof id === 'string' ? id : '—');
};

export const deptLabel = (department) => {
    const id = typeof department === 'object' && department
        ? (department.id || department._id || department.name)
        : department;
    return departments.find((item) => item.id === id)?.name || (typeof id === 'string' ? id : '');
};

export const placeLabel = (place) => {
    const id = typeof place === 'object' && place ? (place.id || place._id || place.name) : place;
    return places.find((item) => item.id === id)?.name || (typeof id === 'string' ? id : '');
};

export const operatorId = (row) => row?._id || row?.id;

export const fullName = (row) => {
    if (!row) return '';
    const source = row.fullname && typeof row.fullname === 'object' ? row.fullname : row;
    if (typeof row.fullname === 'string' && row.fullname.trim()) return row.fullname.trim();
    if (source?.name && typeof source.name === 'object') {
        return [source.name.last, source.name.first, source.name.second].filter(Boolean).join(' ');
    }
    if (typeof source.last === 'string' || typeof source.first === 'string') {
        return [source.last, source.first, source.second].filter(Boolean).join(' ');
    }
    if (typeof row.name === 'string' && row.name.trim()) return row.name.trim();
    return row.login || '';
};

export const initials = (name = '') => {
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '—';
    return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase();
};

export const fmtPhone = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('375')) {
        return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)}-${digits.slice(8, 10)}-${digits.slice(10)}`;
    }
    return value || '';
};

export const mobilePhone = (row) => row?.contact?.phone?.mobile || '';
export const otherPhone = (row) => row?.contact?.phone?.mobile2 || '';
export const telegram = (row) => row?.contact?.telegram || '';
export const telegramLinked = (row) => Boolean(
    row?.telegramId || row?.contact?.telegramId || telegram(row)
);

export const telegramHref = (row) => {
    const handle = String(telegram(row) || '').replace(/^@/, '');
    return handle ? `https://t.me/${handle}` : '';
};

export const formatAddress = (address = {}) => {
    const parts = [
        address.state ? `${address.state} обл.` : '',
        address.district ? `${address.district} р-н` : '',
        address.city,
        address.street,
        address.house,
        address.block,
        address.flat ? `кв. ${address.flat}` : '',
    ].filter(Boolean);
    return parts.join(', ');
};

export const isActive = (row) => row?.status === 'Active';

export const statusMeta = (row) => {
    if (row?.status === 'Active') return { label: 'Активен', chip: 'pc-emp-chip--ok' };
    if (row?.status === 'Absence') return { label: 'Отсутствует', chip: 'pc-emp-chip--warn' };
    return { label: 'Отключён', chip: 'pc-emp-chip--bad' };
};

export const fmtDate = (value) => (value ? moment(value).format('DD.MM.YYYY') : '');

/** Дата без сдвига часового пояса (для полей вида 2027-01-12T21:00:00.000Z). */
export const fmtDateUtc = (value) => (value ? moment.utc(value).format('DD.MM.YYYY') : '');

export const fmtStamp = (value) => (value ? moment(value).format('DD.MM.YYYY HH:mm') : '');

/** Период расчётника: `MM.YYYY`, `YYYY-MM`, ISO-дата или объект { year, month }. */
export const formatReportPeriod = (period) => {
    const parsed = parseReportPeriod(period);
    return parsed ? parsed.format('MMMM YYYY') : '—';
};

export const parseReportPeriod = (period) => {
    if (period == null || period === '') return null;
    if (period instanceof Date && !Number.isNaN(period.getTime())) return moment(period);
    if (typeof period === 'number' && Number.isFinite(period)) {
        const fromNumber = moment(period);
        return fromNumber.isValid() ? fromNumber : null;
    }
    if (typeof period === 'string') {
        const raw = period.trim();
        const strict = moment(raw, ['MM.YYYY', 'M.YYYY', 'YYYY-MM', 'YYYY-MM-DD', 'DD.MM.YYYY'], true);
        if (strict.isValid()) return strict;
        const iso = moment(raw, moment.ISO_8601, true);
        if (iso.isValid()) return iso;
        const loose = moment(raw);
        return loose.isValid() ? loose : null;
    }
    if (typeof period === 'object') {
        if (period.period) return parseReportPeriod(period.period);
        if (period.$date) return parseReportPeriod(period.$date);
        if (period.year != null && period.month != null) {
            const month = Number(period.month);
            const year = Number(period.year);
            const momentMonth = month >= 1 && month <= 12 ? month - 1 : month;
            const fromParts = moment({ year, month: momentMonth, day: 1 });
            return fromParts.isValid() ? fromParts : null;
        }
        return parseReportPeriod(period.start || period.from || period.date || period.begin);
    }
    return null;
};

export const isTrainingOperator = (row) =>
    (row?.type || row?.operator?.type) === 'test';
